/**
 * Excel Orchestrator — Context Note Section
 *
 * Reuses formatWorkbookContextReminder from promptShared.
 */
export const EXCEL_ORCHESTRATOR_CONTEXT_NOTE = `## Context

The workbook context reminder (injected below or via automated reminders) describes:
- Available sheets and their dimensions
- Named ranges and tables
- Active selection

Use this context to determine which sheet and range to target.
Cross-sheet formulas: prefer quoting sheet names: \`'Sheet Name'!A1\` (always safe, avoids space/special-char bugs).`;
export function getContextNoteSection() {
    return EXCEL_ORCHESTRATOR_CONTEXT_NOTE;
}
